import { Statistics } from "model/Statistics";
import * as firestoreClient from '../script/firestore-client'

const table = 'statistics'

export async function listFromCache(
  filterOps?: firestoreClient.FilterOption[],
  sortOps?: firestoreClient.SortOption[],
  limit?: number
): Promise<Statistics[]> {
  return await firestoreClient.listFromCache(table, filterOps, sortOps, limit) as Statistics[]
}